import { useState, useMemo } from 'react';
import { Spot, CategoryFilter as CategoryFilterType } from '@/types/spots';
import { sampleSpots } from '@/data/sampleSpots';
import SpotsMap from '@/components/spots/SpotsMap';
import SearchBar from '@/components/spots/SearchBar';
import BottomSheet from '@/components/spots/BottomSheet';
import SpotDetailSheet from '@/components/spots/SpotDetailSheet';

const AppTest = () => {
  const [selectedCategory] = useState<CategoryFilterType>('all');
  const [selectedSpot, setSelectedSpot] = useState<Spot | null>(null);
  const [userLocation] = useState<{ lat: number; lng: number } | null>(null);

  const filteredSpots = useMemo(() => {
    if (selectedCategory === 'all') return sampleSpots;
    return sampleSpots.filter((spot) => spot.category === selectedCategory);
  }, [selectedCategory]);

  const handleSelectSpot = (spot: Spot) => {
    setSelectedSpot(spot);
  };

  const handleCloseDetail = () => {
    setSelectedSpot(null);
  };

  return (
    <div className="min-h-screen bg-muted flex flex-col relative">
      {/* Search Bar - Floating at top */}
      <div className="absolute top-0 left-0 right-0 z-40 p-4 pt-12">
        <SearchBar />
      </div>

      {/* Full screen map */}
      <div className="h-screen w-full">
        <SpotsMap
          spots={filteredSpots}
          selectedSpot={selectedSpot}
          onSelectSpot={handleSelectSpot}
          userLocation={userLocation}
        />
      </div>

      {/* Bottom Sheet with cards */}
      <BottomSheet
        spots={filteredSpots}
        selectedSpot={selectedSpot}
        onSelectSpot={handleSelectSpot}
      />

      {/* Detail Sheet when spot selected */}
      <SpotDetailSheet spot={selectedSpot} onClose={handleCloseDetail} />
    </div>
  );
};

export default AppTest;
